import { useEffect } from 'react';

// Calls onEnd after durationMs. Re-arms whenever durationMs or onEnd
// identity changes. Used by templates that have no native "ended" event
// (unlike <video>) and must self-advance via a wall-clock timer.
//
// When the Loop crossfade hands a no-op onEnd (the fading-out layer),
// the effect still re-arms but the timeout fires no-op, then unmounts
// before it would have fired anyway. Safe.
export function useDuration(durationMs: number, onEnd: () => void): void {
  useEffect(() => {
    if (durationMs <= 0) return;
    const t = window.setTimeout(onEnd, durationMs);
    return () => clearTimeout(t);
  }, [durationMs, onEnd]);
}
